export default "https://skrwd-shindan.herokuapp.com/packs/media/images/support_illust_05-1ce2a3e3d0456f95793e83179aecf142.png";